import React from "react";

export default function MerchantModal({ open, title, subtitle, children, onClose }) {
  React.useEffect(
    function bindEscapeKey() {
      if (!open) {
        return undefined;
      }

      function handleKeyDown(event) {
        if (event.key === "Escape") {
          onClose();
        }
      }

      window.addEventListener("keydown", handleKeyDown);

      return function cleanup() {
        window.removeEventListener("keydown", handleKeyDown);
      };
    },
    [onClose, open],
  );

  if (!open) {
    return null;
  }

  return (
    <div
      className="merchant-modal-backdrop"
      role="presentation"
      onClick={function handleBackdropClick(event) {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="merchant-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="merchant-modal-header">
          <div>
            <div className="merchant-modal-title">{title}</div>
            {subtitle ? <div className="merchant-modal-subtitle">{subtitle}</div> : null}
          </div>
          <button
            className="merchant-button merchant-button-ghost"
            type="button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
